import { useRef, useEffect } from "react";

type Props = {
    modalClasses: any,
    isOpen: any, children: any, close: any, id: string
}

const GlobalModal = ({ modalClasses, isOpen, children, close, id = '' }: Props) => {
    const ref = useRef(null);
    //registerVerification, register, passwordVerification
    const closeModal = (e) => {
        if (e.target.id === 'outterDialog' && !['registerVerification', 'registerDetails', 'passwordVerification', 'login', 'register', 'passwordReset'].includes(id)) {
            close()
        }
      };

    useEffect(
        () => {
            const { current: el } = ref
            const myBody = document.body;
            
            if (isOpen) {
                myBody.classList.add('ContactForm__Body--open')
                el?.showModal()
               
            }
            else {
                myBody.classList.remove('ContactForm__Body--open')
                el?.close()
            }
        },
        [isOpen]
    )
 
    return (
        <dialog
            onClick={(e) => {
                e.stopPropagation();
                closeModal(e)
            }}
            ref={ref}
            {...modalClasses}
            id="outterDialog"
        >
            {children}
        </dialog>
    )
}

export default GlobalModal;